<template>
  <div
    class="relative"
    @click="toggleBoxVisibility"
  >
    <ActionPopup
      :is-visible="isBoxVisible"
      :message="$t('Link copied')"
      position="bottom"
    />
    <CustomButton
      type="raw"
      :aria-label="$t('Copy product URL to clipboard')"
      size="lg"
    >
      <span class="flex items-center gap-2">
        <i class="iconify svg--share text-EXPONDO-grey text-3xl" />
        <span
          v-if="title"
          class="text-sm text-EXPONDO-grey"
        >
          {{ title }}
        </span>
      </span>
    </CustomButton>
  </div>
</template>

<script lang="ts">

import { Logger } from '~~/helpers/logger';

export default defineComponent({
  name: 'ShareUrl',
  props: {
    url: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  },

  setup(props) {

    const isBoxVisible = ref(false);
    const url = toRef(props, 'url');
    const toggleBoxVisibility = async () => {

      isBoxVisible.value = !isBoxVisible.value;
      try {

        const shareUrl = url.value || window.location.href;

        await navigator.clipboard.writeText(shareUrl);

      } catch (err) {

        Logger.error('Failed to copy: ', err);

      }

      if (isBoxVisible.value) {

        setTimeout(() => {

          isBoxVisible.value = false;

        }, 2000);

      }

    };

    return {
      isBoxVisible,
      toggleBoxVisibility,
    };

  },
});

</script>
